import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=cfd32fbe&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationBar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=cfd32fbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd32fbe",
  null
  
)

export default component.exports